import React from 'react';
import ParticipantsList from '../ParticipantsList';
import TranscriptionSettings from './TranscriptionSettings';
import StatsDisplay from './StatsDisplay';
import {LANGUAGE_OPTIONS} from "../../../constants";
import {SettingsIcon, X} from "lucide-react";
import SettingsActions from "./Actions";

const SettingsSidebar = ({
                             participants,
                             userId,
                             myChannel,
                             isMuted,
                             otherParticipantMuted,
                             isCallConnected,
                             settings,
                             updateSettings,
                             transcriptions,
                             audioStats,
                             onClearHistory,
                             onClose
                         }) => {
    return (
        <>
            {/* Mobile: Backdrop */}
            <div
                className="md:hidden fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
                onClick={onClose}
            ></div>

            <div
                className="fixed md:relative right-0 top-0 bottom-0 w-full sm:w-96 md:w-80 lg:w-96 glass-panel border-l border-white/10 overflow-y-auto flex flex-col z-50 md:z-auto">
                <div
                    className="sticky top-0 glass-panel border-b border-white/10 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between z-10">
                    <div className="flex items-center gap-2">
                        <SettingsIcon className="w-4 h-4 sm:w-5 sm:h-5 text-orange-400"/>
                        <h2 className="text-base sm:text-lg font-semibold text-white">Settings</h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="lg:hidden p-2 bg-white/5 hover:bg-white/10 rounded-lg transition-all"
                    >
                        <X className="w-5 h-5 text-white"/>
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto px-4 sm:px-6 py-4 space-y-4 sm:space-y-6">
                    {/* Participants List */}
                    <ParticipantsList
                        participants={participants}
                        userId={userId}
                        myChannel={myChannel}
                        isMuted={isMuted}
                        otherParticipantMuted={otherParticipantMuted}
                        isCallConnected={isCallConnected}
                    />

                    {/* Transcription Settings */}
                    <TranscriptionSettings
                        settings={settings}
                        updateSettings={updateSettings}
                        languages={LANGUAGE_OPTIONS}
                    />

                    {/* Stats */}
                    <StatsDisplay
                        transcriptionsCount={transcriptions.length}
                        audioStats={audioStats}
                    />

                    {/* Actions */}
                    <SettingsActions
                        onClearHistory={onClearHistory}
                    />
                </div>
            </div>
        </>

    );
};

export default SettingsSidebar;
